export enum ChatMessageReactionType {
    LIKE = 'Like',
    HIGH_FIVE = 'High Five',
    LAUGH = 'Laugh',
    WOW = 'Wow'
}
